import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useScreenSize } from '@/hooks';
import PremiumButton from '@/components/common/PremiumButton';
import { SecondaryButton } from '@/components/common/Button/Button';
import styles from './LogoutModal.module.css';

/**
 * LogoutModal Component
 * Custom non-full-screen logout confirmation modal
 * Compact modal for mobile and desktop
 */
const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const { isMobile } = useScreenSize();

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={`${styles.modal} ${isMobile ? styles.mobile : ''}`}>
          {/* Header */}
          <div className={styles.header}>
            <h2 className={styles.title}>{t('logout.signingOut')}</h2>
            <button
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close modal"
            >
              <X size={22} />
            </button>
          </div>

          {/* Content */}
          <div className={styles.content}>
            <p className={styles.message}>
              {t('logout.logoutConfirm')}
            </p>
            <div className={styles.buttonContainer}>
              <SecondaryButton onClick={onClose}>
                {t('common.cancel')}
              </SecondaryButton>
              <PremiumButton onClick={onConfirm}>
                {t('logout.signOut')}
              </PremiumButton>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default LogoutModal;
